import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed person details',
  name: 'changed_person_details',
  params: [
    {
      description: 'Person ID',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'New name',
      name: 'new_name',
      required: false,
      type: 'string',
    },
    {
      description: 'New title',
      name: 'new_title',
      required: false,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'image-preview',
        'people-tab',
        'unnamed-people-page',
        'people-settings',
        'person-page-header',
        'person-page-menu',
      ],
    },
  ],
};

export default META;
